import axios from 'axios'

let copyscapeURL = 'https://k53vxm3nzg.execute-api.eu-central-1.amazonaws.com/prod/'

export const copyscapeHTTP = axios.create({
  baseURL: copyscapeURL,
})
